import { render, staticRenderFns } from "./ResumoPedidoManutencao.vue?vue&type=template&id=0d5e77de&scoped=true&"
import script from "./ResumoPedidoManutencao.vue?vue&type=script&lang=js&"
export * from "./ResumoPedidoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ResumoPedidoManutencao.vue?vue&type=style&index=0&id=0d5e77de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5e77de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VScrollYTransition})
